import { render, staticRenderFns } from "./left_yellow.vue?vue&type=template&id=1f7a5afd&scoped=true"
import script from "./left_yellow.vue?vue&type=script&lang=js"
export * from "./left_yellow.vue?vue&type=script&lang=js"
import style0 from "./left_yellow.vue?vue&type=style&index=0&id=1f7a5afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a5afd",
  null
  
)

export default component.exports